<template>
  <div class="tags-view">
    <router-link
      v-for="tag in visitedViews"
      :key="tag.fullPath"
      :to="tag.fullPath"
      class="tags-view-link">
      <el-tag
        :closable="tag.path !== '/home'"
        :type="isActive(tag) ? '' : 'info'"
        class="tags-view-item"
        @close="closeTag(tag, $event)">
        {{ tag.title }}
      </el-tag>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      visitedViews: [{ path: '/home', fullPath: '/home', title: '首页' }]
    }
  },
  created() {
    this.$root.$on('close-visited-view', this.closeVisitedView)
  },
  beforeDestroy() {
    this.$root.$off('close-visited-view', this.closeVisitedView)
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.name && !this.visitedViews.some(tag => tag.fullPath === route.fullPath)) {
          this.visitedViews.push({
            path: route.path,
            fullPath: route.fullPath,
            title: route.meta.title || route.name
          })
        }
      }
    }
  },
  methods: {
    isActive(tag) {
      return tag.fullPath === this.$route.fullPath
    },
    closeTag(tag, event) {
      event.preventDefault()
      this.closeVisitedView(tag.fullPath)
    },
    closeVisitedView(fullPath) {
      const index = this.visitedViews.findIndex(item => item.fullPath === fullPath)
      if (index === -1) return
      const tag = this.visitedViews[index]
      this.visitedViews.splice(index, 1)
      if (this.isActive(tag)) {
        const next = this.visitedViews[index] || this.visitedViews[index - 1]
        this.$router.push(next.fullPath)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tags-view {
  height: 40px;
  padding: 6px 10px;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  line-height: 28px;
  white-space: nowrap;
  border-bottom: 1px solid #d8dce5;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
}

.tags-view::-webkit-scrollbar {
  display: none;
}

.tags-view-link {
  display: inline-block;
  margin-right: 6px;
}

.tags-view-item {
  height: 28px;
  line-height: 26px;
  cursor: pointer;
}

@media (max-width: 1024px) {
  .tags-view {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TagsView.vue